import { axios } from "../config";
import { EMITTER_ERROR } from "../utils/constants";
import { authEndpoints } from "../utils/constants/httpConstants";
import EventEmitter from "../utils/emitter/EventEmitter";
import { LOGIN_PATH } from "../utils/constants/routes";

// Get Request
export const GET = async (url) => {
  try {
    return await axios.get(url);
  } catch (error) {
    // Fix #5: on a network/timeout/DNS error there is no `error.response` — don't throw `undefined`
    // (the failure would vanish at the caller). Throw a normalized shape callers already read.
    throw error?.response || { status: 0, data: { message: error?.message || "Network error. Please check your connection and try again." } };
  }
};
// Post request
export const POST = async (url, payload) => {
  try {
    return await axios.post(url, payload);
  } catch (error) {
    // Fix #5: normalize network/transport errors (no error.response) instead of throwing undefined.
    throw error?.response || { status: 0, data: { message: error?.message || "Network error. Please check your connection and try again." } };
  }
};

// Protected Api's Wrapper
export const getRequest = async (navigate, url) => {
  let response;
  try {
    response = await axios.get(url);
    return response;
  } catch (error) {
    if (error?.response?.status === 401 || error?.response?.status === 477) {
      try {
        await axios.post(authEndpoints.checkLogin);
        const res = await axios.get(url);
        return res;
      } catch (err) {
        if (err?.response?.status === 401 || err?.response?.status === 477) {
          // now user is logout;
          EventEmitter.emit(
            EMITTER_ERROR,
            err?.response?.data?.message || err?.message
          );
          navigate(LOGIN_PATH);
        }
        throw err?.response;
      }
    } else if (
      error?.response?.status === 426 ||
      error?.response?.status === 427
    ) {
      //   navigate(INITIAL_ROUTE);
    } else {
      throw error?.response;
    }
  }
};

export const postRequest = async (navigate, url, payload, headers = {}) => {
  let response;
  try {
    response = await axios.post(url, payload, { headers });
    return response;
  } catch (error) {
    if (error?.response?.status === 401 || error?.response?.status === 477) {
      try {
        await axios.post(authEndpoints.checkLogin);
        const res = await axios.post(url, payload);
        return res;
      } catch (err) {
        if (err?.response?.status === 401 || err?.response?.status === 477) {
          // now user is logout;
          EventEmitter.emit(
            EMITTER_ERROR,
            err?.response?.data?.message || err?.message
          );
          navigate(LOGIN_PATH);
        }
        throw error?.response;
      }
    } else if (error?.response?.status === 426) {
      //   navigate(INITIAL_ROUTE);
    } else {
      throw error?.response;
    }
  }
};

export const putRequest = async (navigate, url, payload) => {
  let response;
  try {
    response = await axios.put(url, payload);
    return response;
  } catch (error) {
    if (error?.response?.status === 401 || error?.response?.status === 477) {
      try {
        await axios.post(authEndpoints.checkLogin);
        const res = await axios.put(url, payload);
        return res;
      } catch (err) {
        if (err?.response?.status === 401 || err?.response?.status === 477) {
          // now user is logout;
          EventEmitter.emit(
            EMITTER_ERROR,
            err?.response?.data?.message || err?.message
          );
          navigate(LOGIN_PATH);
        }
        throw error?.response;
      }
    } else {
      throw error?.response;
    }
  }
};
export const patchRequest = async (navigate, url, payload) => {
  let response;
  try {
    response = await axios.patch(url, payload);
    return response;
  } catch (error) {
    if (error?.response?.status === 401 || error?.response?.status === 477) {
      try {
        await axios.post(authEndpoints.checkLogin);
        const res = await axios.patch(url, payload);
        return res;
      } catch (err) {
        if (err?.response?.status === 401 || err?.response?.status === 477) {
          // now user is logout;
          EventEmitter.emit(
            EMITTER_ERROR,
            err?.response?.data?.message || err?.message
          );
          navigate(LOGIN_PATH);
        }
        throw error?.response;
      }
    } else {
      throw error?.response;
    }
  }
};

export const deleteRequest = async (url, payload) => {
  let response;
  try {
    response = await axios.delete(url, { data: payload });
    return response;
  } catch (error) {
    if (error?.response?.status === 401 || error?.response?.status === 477) {
      try {
        await axios.post(authEndpoints.checkLogin);
        const res = await axios.delete(url, { data: payload });
        return res;
      } catch (err) {
        if (err?.response?.status === 401 || err?.response?.status === 477) {
          // now user is logout;
          EventEmitter.emit(
            EMITTER_ERROR,
            err?.response?.data?.message || err?.message
          );
        }
        throw error?.response;
      }
    } else {
      throw error?.response;
    }
  }
};
